import { Heading } from "iparque-components";
import React, { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import DemoImage from "../DemoImage";
import Form from "../Form";
import { DemonstrationMenu } from "../interfaces";
import {
  Container,
  FormContainer,
  ImageContainer,
  LeftContainer,
} from "./styles";

const LargeDevicesDemonstration: React.FC<DemonstrationMenu> = ({
  isOpen,
  toggle,
}) => {
  const { t } = useTranslation();

  const onClickAnywhereHandler = useCallback(() => {
    if (isOpen) {
      toggle();
    }
  }, [isOpen, toggle]);

  const onClickContainerHandler = useCallback(
    (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      event.stopPropagation();
    },
    []
  );

  useEffect(() => {
    window.addEventListener("click", onClickAnywhereHandler);

    return () => {
      window.removeEventListener("click", onClickAnywhereHandler);
    };
  }, [onClickAnywhereHandler]);

  return (
    <Container isOpen={isOpen} onClick={onClickContainerHandler}>
      <LeftContainer onClick={toggle}>
        <Heading variant="h7" elementType="h2" className="title">
          {t("9248") /* Demonstração! */}
        </Heading>
        <ImageContainer>
          <DemoImage isOpen={isOpen} />
        </ImageContainer>
      </LeftContainer>
      <div className="right-container">
        <FormContainer>
          <Form onSuccess={toggle} />
        </FormContainer>
      </div>
    </Container>
  );
};

export default LargeDevicesDemonstration;
